
import { debouncePromise } from '@flamingo_tech/funkgo-utils/promiseUtils'
import composeInstallation from '../utils/composeInstallation'


const installGoogleSdk = composeInstallation({
  name: 'googleLogin',
  makeScriptUri: () => 'https://accounts.google.com/gsi/client'
})

const install = debouncePromise(installGoogleSdk)

const init = () => {

  if (window.GoogleLogin) {
    return window.GoogleLogin
  }

  window.GoogleLogin = install()

  return window.GoogleLogin

}

export {
  init
}